(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/nav-context/assets/javascripts/nav-context.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/nav-context/assets/javascripts/nav-context.js');
"use strict";


const _React = React,
  createContext = _React.createContext;
const NavContext = createContext();
setGlobal('svs.oddset_kambi.components.nav_context.NavContext', NavContext);

 })(window);